export default "__VITE_ASSET__Bj7$Mac2__"